// Blockchain platform & core service pages
import {cdnUrl} from '@/util/cdnImage';
import type {PageHeadMeta} from '@/components/PageHead';

export const WEB3_META_DATA: PageHeadMeta = {
    title: 'Web3 Application Development Services for Businesses | Debut Infotech',
    img: cdnUrl('web3/Web3-development-company.jpg'),
    description:
        'Explore Web3 application development services from Debut Infotech. Build secure dApps, smart contracts, DeFi platforms, NFT marketplaces and scalable blockchain solutions.'
};

export const BLOCKCHAIN_META_DATA: PageHeadMeta = {
    title: 'Blockchain Development Company | Debut Infotech',
    img: cdnUrl('Blockchain-images/Blockchain-Development.jpg'),
    description:
        'Scale your business with Debut Infotech’s enterprise blockchain development services. We build secure dApps, smart contracts, Web3 platforms, and custom tokenization systems.'
};

export const SMART_CONTRACT_META_DATA: PageHeadMeta = {
    title: 'Custom Smart Contract Development Company for Web3 Projects',
    img: cdnUrl('meta-images/Smart-Contract-banner-img.jpg'),
    description:
        'Partner with Debut Infotech for secure smart contract development services. We build, audit and deploy Web3, DeFi, DAO, NFT and tokenization solutions across leading blockchains.'
};

export const CUSTOM_WEB_META_DATA: PageHeadMeta = {
    title: 'Custom Blockchain Development Solutions  | Debut Infotech',
    description:
        'Debut Infotech provides custom blockchain development solutions to a variety of sectors to create the best custom blockchain solution for your business.'
};

export const DAPP_META_DATA: PageHeadMeta = {
    title: 'DApp Development Company & Services | Debut Infotech',
    img: cdnUrl('images/dapp-images/dApp-Development-Company.jpg'),
    description:
        'Debut Infotech delivers custom dApp development for startups and enterprises, with secure smart contracts, wallet integrations, and scalable blockchain architecture.'
};

export const DAO_META_DATA: PageHeadMeta = {
    title: 'DAO Development Services & Solutions | Debut Infotech',
    img: cdnUrl('meta-images/dao.jpg'),
    description: `Build and launch a secure DAO with Debut Infotech. We help startups and enterprises build secure DAO platforms, governance systems, voting mechanisms and treasury solutions.`
};

export const BLOCKCHAIN_TECHNOLOGY_META_DATA: PageHeadMeta = {
    title: 'What is Blockchain Technology | Why is Blockchain Important',
    description: 'Learn about what is Blockchain Technology and why it is important in revolutionizing various industries in detail.',
    img: cdnUrl('meta-images/blockchain-technology-bg.jpg')
};

export const POLYGON_META_DATA: PageHeadMeta = {
    title: 'Polygon blockchain development company',
    description:
        'Unlock the full potential of your blockchain projects with our expert Polygon development services. Custom solutions tailored for your business success.',
    img: cdnUrl('polygon-images/Polygon-Blockchain-Development-Company.png')
};

export const BLOCKCHAIN_GAME_META_DATA: PageHeadMeta = {
    title: 'Blockchain Game Development Company | NFT & Web3 Games | Debut Infotech',
    description:
        'As a leading blockchain game development company, we create NFT, P2E, Web3 and metaverse games with secure smart contracts and scalable architecture.',
    img: cdnUrl('blockchain-game/blockchain-game-development.jpg')
};

export const BLOCKCHAIN_CONSULTING_META_DATA: PageHeadMeta = {
    title: 'Blockchain Consulting Services | Blockchain Consultants',
    description:
        'Drive innovation with expert blockchain consulting services. Our blockchain consultants provide innovative solutions, ensuring secure blockchain integration.',
    img: cdnUrl('Blockchain-consuting-images/Blockchain-Consulting-Services-banner.jpg')
};

export const SOLANA_META_DATA: PageHeadMeta = {
    title: 'Solana Blockchain Development Company',
    description:
        'Get scalable, high-performance Solana blockchain development services for DeFi, NFTs, and dApps. Build secure, fast, and cost-efficient solutions today!',
    img: cdnUrl('Solana-images/Solana-Blockchain-Development-Company.jpg')
};

export const HYPERLEDGER_META_DATA: PageHeadMeta = {
    title: 'Hyperledger Development Company | Hyperledger Development Services',
    description:
        'Partner with a top Hyperledger development company offering tailored Hyperledger development services for secure, scalable, and enterprise-grade blockchain apps.',
    img: cdnUrl('hyperledger-images/Hyperledger-Blockchain-Development-Services.jpg')
};

export const ENTERPRISE_BLOCKCHAIN_DEVELOPMENT: PageHeadMeta = {
    title: 'Enterprise Blockchain Development Services',
    description:
        'We offer expert Enterprise Blockchain Development Services tailored for secure and scalable blockchain solutions for innovation and growth. Request a quote now!',
    img: cdnUrl('enterprise-blockchain/Enterprise-Blockchain-Development-Company.jpg')
};

export const PUBLIC_BLOCKCHAIN_DEVELOPMENT: PageHeadMeta = {
    title: 'Public Blockchain Development Services',
    description:
        'Utilize our Public Blockchain Development Services to build transparent, decentralized solutions that drive trust and innovative growth.',
    img: cdnUrl('public-blockchain/Public-Blockchain-Development-company.jpg')
};

export const PRIVATE_BLOCKCHAIN_DEVELOPMENT: PageHeadMeta = {
    title: 'Private Blockchain Development Services',
    description:
        'Unlock enhanced security and efficiency with our Private Blockchain Development Services. We design custom, scalable blockchain solutions tailored to streamline your business operations.',
    img: cdnUrl('Private-blockchain/Private-Blockchain-Development-Company.jpg')
};

export const SMART_CONTRACT_AUDIT_META_DATA: PageHeadMeta = {
    title: 'Smart Contract Audit Service by Debut Infotech',
    description:
        'Protect your blockchain project with expert smart contract audit services. Identify vulnerabilities, prevent exploits and secure DeFi, Web3 and blockchain applications before deployment.',
    img: cdnUrl('Smart-contract-auditing/Smart-contract-auditing.jpg')
};

export const POLKADOT_BLOCKCHAIN_DEVELOPMENT: PageHeadMeta = {
    title: 'Polkadot Blockchain Development Company',
    description:
        'Leverage our Polkadot blockchain development services to build scalable, secure, and interoperable decentralized applications. Contact us for expert solutions.',
    img: cdnUrl('Polkadot-Blockchain-Development-Company/Polkadot-Blockchain-Development-Company.jpg')
};

export const COSMOS_BLOCKCHAIN_DEVELOPMENT: PageHeadMeta = {
    title: 'Cosmos Blockchain Development Services',
    description:
        'Discover top-notch Cosmos blockchain development services to build scalable, secure, and efficient solutions with our expert developers.',
    img: cdnUrl('Cosmos-Blockchain-Development/Cosmos-Blockchain-Development-Company.jpg')
};

export const CARDANO_BLOCKCHAIN_DEVELOPMENT: PageHeadMeta = {
    title: 'Cardano Blockchain Development Company',
    description:
        'Hire a top Cardano blockchain development company to build secure, scalable, and smart contract-powered solutions for your business.',
    img: cdnUrl('Cardano-development-company/Cardano-Blockchain-Development-Company.jpg')
};

export const BLOCKCHAIN_AI_DEVELOPMENT: PageHeadMeta = {
    title: 'Blockchain AI Development | AI & Blockchain Integration',
    description:
        'Unlock innovation with Blockchain AI development. Integrate AI and blockchain for enhanced security, automation, and smarter decentralized solutions.',
    img: cdnUrl('Blockchain-ai-development/Blockchain-Ai-Development.jpg')
};

export const ETHEREUM_DEVELOPMENT_SERVICE: PageHeadMeta = {
    title: 'Ethereum Development Services | Ethereum Blockchain Platform',
    description:
        'Get expert Ethereum development services for DApps, smart contracts, and DeFi platforms. Build secure and scalable blockchain solutions today!',
    img: cdnUrl('Ethereum-Development-Services/Ethereum-Development-Services.jpg')
};

export const BLOCKCHAIN_DEVELOPMENT_COMPANY_IN_UK: PageHeadMeta = {
    title: 'Blockchain Development Company in UK',
    description:
        'Debut Infotech, a top Blockchain Development Company in UK, delivers custom blockchain solutions, smart contracts, and dApps for business growth.',
    img: cdnUrl('Blockchain-development-in-uk/Blockchain-Development-Company-uk.jpg')
};
